<template>
  <div
    class="card px-2 py-2 mt-3 wrapper-prehgsi"
    v-if="prehgsiData.vendas.length > 0 || prehgsiData.posvendas.length > 0"
  >
    <div>
      <button class="btn" style="box-shadow: none;" @click="visible = !visible">
        <i class="fab fa-buffer"></i>
        {{ this.$t('reports.prehgsi.prehgsiLabel') }}
      </button>
      <button
        class="btn pull-right"
        style="box-shadow: none;"
        @click="visible = !visible"
      >
        <i class="fas fa-angle-double-right" v-if="!visible"></i>
        <i v-else class="fas fa-angle-double-down"></i>
      </button>
    </div>
    <div class="wrapper-prehgsi card" v-if="loader">
      <div>
        <div class="loader d-flex justify-content-center align-items-center">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div>
      </div>
    </div>
    <div v-else>
      <b-collapse v-model="visible" class="mt-2">
        <!-- VENDAS -->
        <div v-if="itemsVendas.length > 0">
          VENDAS
          <div style="display: flex;">
            <div class="prehgsi-chart col-3">
              <radial-progress-bar
                v-if="vendasScore !== null && vendasScore !== undefined"
                :diameter="240"
                :stroke-width="20"
                innerStrokeColor="#f1f1f1"
                :startColor="colorBalanceS"
                :stopColor="colorBalanceS"
                :completed-steps="vendasScore ? parseInt(vendasScore) : 0"
                :total-steps="1000"
              >
                <b
                  id="prehgsi-vendas"
                  v-b-modal.drilldownReport
                  :style="{
                    color: colorBalanceS,
                    fontSize: '2.8em',
                    fontWeight: 'bold',
                  }"
                  >{{ vendasScore }}
                  <drilldownReport
                    :answers="respostas"
                    :questions="prehgsiData.vendas"
                    title="PRE-HGSI Vendas"
                  />
                </b>
                <b-tooltip
                  v-if="vendasScore !== null && vendasScore !== undefined"
                  target="prehgsi-vendas"
                  placement="bottom"
                >
                  Vendas
                  <strong>{{ vendasScore }}</strong>
                </b-tooltip>
              </radial-progress-bar>
              <div v-else>
                Sem dados para exibir
              </div>
            </div>
            <b-table
              :items="itemsVendas"
              caption-bottom
              :fields="fields"
              sort-icon-left
            >
              <template v-slot:cell(progress)="row">
                <div class="mt-2">
                  <b-progress :value="row.item.progress" :max="1000">
                  </b-progress>
                </div>
              </template>
              <template v-slot:cell(score)="row">
                <div class="text-right">
                  {{ row.item.score }}
                </div>
              </template>
              <template v-slot:cell(total)="row">
                <div class="text-center">
                  {{ row.item.total }}
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <!-- POSVENDAS -->
        <div v-if="itemsPosvendas.length > 0">
          PÓS-VENDAS
          <div style="display: flex;">
            <div class="prehgsi-chart col-3">
              <radial-progress-bar
                v-if="posvendasScore !== null && posvendasScore !== undefined"
                :diameter="240"
                :stroke-width="20"
                innerStrokeColor="#f1f1f1"
                :startColor="colorBalanceAS"
                :stopColor="colorBalanceAS"
                :completed-steps="posvendasScore ? parseInt(posvendasScore) : 0"
                :total-steps="1000"
              >
                <b
                  id="prehgsi-posvendas"
                  v-b-modal.drilldownReport
                  :style="{
                    color: colorBalanceAS,
                    fontSize: '2.8em',
                    fontWeight: 'bold',
                  }"
                  >{{ posvendasScore }}
                  <drilldownReport
                    :answers="respostas"
                    :questions="prehgsiData.posvendas"
                    title="PRE-HGSI Pós-Vendas"
                  />
                </b>
                <b-tooltip
                  v-if="posvendasScore !== null && posvendasScore !== undefined"
                  target="prehgsi-posvendas"
                  placement="bottom"
                >
                  Pós-Vendas
                  <strong>{{ posvendasScore }}</strong>
                </b-tooltip>
              </radial-progress-bar>
              <div v-else>
                Sem dados para exibir
              </div>
            </div>
            <b-table
              :items="itemsPosvendas"
              caption-bottom
              :fields="fields"
              sort-icon-left
            >
              <template v-slot:cell(progress)="row">
                <div class="mt-2">
                  <b-progress :value="row.item.progress" :max="1000">
                  </b-progress>
                </div>
              </template>
              <template v-slot:cell(score)="row">
                <div class="text-right">
                  {{ row.item.score }}
                </div>
              </template>
              <template v-slot:cell(total)="row">
                <div class="text-center">
                  {{ row.item.total }}
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import api from '@/services/api';
import drilldownReport from '@/components/molecules/highcharts/reports/rankings/components/modal-drilldown';

export default {
  name: 'PrehgsiReport',
  components: {
    RadialProgressBar,
    animatedNumber,
    drilldownReport,
  },

  props: ['showCollapsed'],

  data: () => ({
    filter: null,
    userAuth: null,
    visible: true,
    page: 1,
    limit: 10,
    prehgsiData: {
      vendas: [],
      posvendas: [],
    },
    loader: false,
    itemsVendas: [],
    itemsPosvendas: [],
    vendasScore: null,
    posvendasScore: null,
    fields: [],
    respostas: [],
    colorBalanceS: '#fff',
    colorBalanceAS: '#fff',
  }),

  watch: {
    actionGroupData: function watchActionGroupData() {
      this.mountPHGSI();
    },
    myActionId: function watchMyActionId() {
      this.mountPHGSI();
    },
    myActionsIds: function watchMyActionsIds() {
      this.mountPHGSI();
    },
    myIh1: function watchMyIh1() {
      this.mountPHGSI();
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.mountPHGSI();
    },
    myIh2: function watchMyIh2() {
      this.mountPHGSI();
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.mountPHGSI();
    },
    calendarDates: function watchDates() {
      this.mountPHGSI();
    },
    myMetric: function watchMyMetric() {
      this.mountPHGSI();
    },
    'indicatorData.value': function watchMyMetric() {
      this.mountPHGSI();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.mountPHGSI();
    },
  },

  computed: {
    ...mapState('actions', ['myActionId','myActionsIds', 'actionGroupData', 'allActions']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'ih1', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  methods: {
    async mountPHGSI() {
      this.loader = true;
      const response = await api.get(`reports/prehgsi`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          companyId: this.userAuth.companyId,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });
      this.prehgsiData = response.data;
      this.respostas = this.prehgsiData.respostas;
      // builds info for VENDAS
      this.itemsVendas = [];
      this.vendasScore = null;
      this.prehgsiData.vendas.map((obj) => {
        this.itemsVendas.push({
          question: obj.question,
          progress: (obj.average * 100).toFixed(0),
          score: (obj.average * 100).toFixed(0),
          total: obj.total,
        });
      });
      this.vendasScore = (100 * this.prehgsiData.vendasPrehgsi).toFixed(0);
      this.setColorS(this.vendasScore);
      // builds info for POSVENDAS
      this.itemsPosvendas = [];
      this.posvendasScore = null;
      this.prehgsiData.posvendas.map((obj) => {
        this.itemsPosvendas.push({
          question: obj.question,
          progress: (obj.average * 100).toFixed(0),
          score: (obj.average * 100).toFixed(0),
          total: obj.total,
        });
      });
      this.posvendasScore = (100 * this.prehgsiData.posvendasPrehgsi).toFixed(
        0,
      );
      this.setColorAS(this.posvendasScore);
      this.loader = false;
    },
    setColorS(percentBalance) {
      if (percentBalance >= 950) {
        this.colorBalanceS = '#6bca6c';
      } else if (percentBalance < 950 && percentBalance >= 800) {
        this.colorBalanceS = '#fbcf3f';
      } else if (percentBalance < 800) {
        this.colorBalanceS = 'red';
      }
    },
    setColorAS(percentBalance) {
      if (percentBalance >= 950) {
        this.colorBalanceAS = '#6bca6c';
      } else if (percentBalance < 950 && percentBalance >= 800) {
        this.colorBalanceAS = '#fbcf3f';
      } else if (percentBalance < 800) {
        this.colorBalanceAS = 'red';
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.fields = [
      {
        key: 'question',
        label: this.$t('reports.prehgsi.addQuestionLabel'),
        sortable: true,
        class: 'questionPreHgsi',
      },
      { key: 'progress', class: 'progressPreHgsi' },
      {
        key: 'score',
        label: this.$t('reports.prehgsi.scoreLabel'),
        sortable: true,
        class: 'scorePreHgsi',
      },
      {
        key: 'total',
        label: this.$t('reports.prehgsi.totalLabel'),
        sortable: true,
        class: 'totalPreHgsi',
      },
    ];
  },

  mounted() {
    this.visible = !this.showCollapsed;
    if (this.userAuth.companyId === '6107f837f50c776b205ebf48') {
      this.mountPHGSI();
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/themes/default/variables.scss';

.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-prehgsi .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-prehgsi .btn .btn-light .collapsed {
  background-color: transparent;
}
.card {
  border: 1px solid rgba(0, 0, 0, 0.09);
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;

  transition: color 0.2s;

  &:hover {
    color: #1dc86e;
  }
}
.prehgsi-chart {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 30px);
}
</style>
<style>
.progressPreHgsi {
  width: 400px;
}
.scorePreHgsi {
  width: 70px;
  padding-right: 0px !important;
}
.totalPreHgsi {
  width: 70px;
  padding-right: 0px !important;
}
.questionPreHgsi {
  width: calc(100% - 500px);
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/rankings/components/prehgsi.vue